import get from 'lodash/get'
export const isRequiredField = (validationSchema, fieldName) => {
  const schema = fieldName.split('.').reduce((acc, field) => {
    const tests = get(acc.fields, field)
    if (tests) acc = tests
    return acc
  }, validationSchema.describe())

  if (schema && schema.tests) {
    return !!schema.tests.find(({ name }) => ['required', 'min'].includes(name))
  }
  return false
}
